module.exports = __webpack_public_path__ + "static/kv-network-622007a6f3798cc95518fc58146f4c46.png";